import React from 'react';
import { EnumSortDirection, ISortField } from './useRequest';

export interface ISort {
    sortField?: ISortField,
    requestedSortField?: ISortField,
    isColumnSorted: (name: string) => boolean,
    handleSortFieldRequest: (name: string) => () => void,
    updateSortField: (sortField: ISortField) => void
}

export function useSort (initialSort?: ISortField) : ISort {
    if (initialSort !== undefined && initialSort.direction === undefined) {
        initialSort.direction = EnumSortDirection.Asc;
    }

    const [_sortField, _setSortField] = React.useState<ISortField | undefined>(initialSort);
    const [_requestedSortField, _setRequestedSortField] = React.useState<ISortField | undefined>(initialSort);

    const isColumnSorted = React.useCallback((name: string) => {
        return _sortField?.name === name;
    }, [_sortField]);

    const handleSortFieldRequest = React.useCallback((name: string) => () => {
        let direction: EnumSortDirection = EnumSortDirection.Asc;

        if (isColumnSorted(name) && _sortField !== undefined && _sortField?.direction !== EnumSortDirection.Desc) {
            direction = EnumSortDirection.Desc;
        }

        _setRequestedSortField({
            name,
            direction
        });
    }, [_sortField, isColumnSorted]);

    const updateSortField = React.useCallback((sortField: ISortField) => {
        _setSortField(sortField);
    }, []);

    return React.useMemo(() => ({
        sortField: _sortField,
        requestedSortField: _requestedSortField,
        isColumnSorted,
        handleSortFieldRequest,
        updateSortField,
    }), [_requestedSortField, _sortField, handleSortFieldRequest, isColumnSorted, updateSortField])
}